import { Navigate, Outlet } from 'react-router-dom'

import { isSiteWorker, useCurrentUser } from '@/features/auth'
import { JobsPage } from '@/features/jobs'
import { SiteWorkerHomePage } from '@/features/site-worker'
import { AppLayout } from '@/routes/app-layout'
import { SiteWorkerLayout } from '@/routes/site-worker-layout'

export const RoleAwareLayout = () => {
  const user = useCurrentUser()

  if (isSiteWorker(user)) {
    return <SiteWorkerLayout />
  }

  return <AppLayout />
}

export const HomeRoute = () => {
  const user = useCurrentUser()

  if (isSiteWorker(user)) {
    return <SiteWorkerHomePage />
  }

  return <JobsPage />
}

export const PortalRoute = () => {
  const user = useCurrentUser()

  if (isSiteWorker(user)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
